export default __webpack_public_path__ + "static/media/alert.d94749c4.svg";